<template>
  <div class="bind-page">
    <div class="page-top">
      <img
        src="/static/image/nav_chevron_back.bb0f0ac706614ab578365b31d203927a.png"
        alt=""
        class="back-btn"
        @click="$router.back()"
      />
      绑定提现账户
    </div>

    <div class="page-body">
      <div v-if="!prerequisiteChecked" class="prerequisite-loading">正在检查实名信息...</div>
      <template v-else-if="hasPayoutPrerequisites">
      <section class="notice-card">
        <div class="notice-title">绑定后不可随意更换</div>
        <div class="notice-text">银行卡、支付宝、USDT 三类账户只能各绑定一次，如需更换请联系客服。</div>
        <div class="notice-text">支付宝绑定需要上传收款码。</div>
        <div class="notice-text">实名信息提交后即可绑定，审核中或未通过不影响绑定。</div>
      </section>

      <section class="form-card">
        <div class="section-title">真实姓名</div>
        <input v-model.trim="realname" class="readonly-input" type="text" readonly :placeholder="realname || '请先完成实名'" />
      </section>

      <section class="form-card">
        <div class="tab-row">
          <button
            v-for="item in tabs"
            :key="item.key"
            type="button"
            class="tab-btn"
            :class="{ active: activeType === item.key }"
            @click="activeType = item.key"
          >
            {{ item.label }}
          </button>
        </div>

        <div v-if="activeType === 'bank'">
          <label class="field">
            <span>开户行</span>
            <input v-model.trim="form.bank.bank_name" type="text" placeholder="如：中国工商银行" :disabled="isLocked('bank')" />
          </label>
          <label class="field">
            <span>银行卡号</span>
            <input v-model.trim="form.bank.account_no" type="text" placeholder="请输入银行卡号" :disabled="isLocked('bank')" />
          </label>
        </div>

        <div v-else-if="activeType === 'alipay'">
          <label class="field">
            <span>支付宝账号</span>
            <input v-model.trim="form.alipay.account_no" type="text" placeholder="手机号或邮箱" :disabled="isLocked('alipay')" />
          </label>
          <label class="field upload-field">
            <span>收款码</span>
            <div class="upload-box">
              <input
                ref="alipayQrcodeInput"
                class="upload-input"
                type="file"
                accept="image/*"
                :disabled="isLocked('alipay')"
                @change="onAlipayQrcodeChange"
              />
              <button type="button" class="upload-btn" :disabled="isLocked('alipay')" @click="pickAlipayQrcode">选择图片</button>
              <div v-if="form.alipay.qrcode_preview" class="upload-preview">
                <img :src="form.alipay.qrcode_preview" alt="支付宝收款码" />
              </div>
            </div>
          </label>
        </div>

        <div v-else>
          <label class="field">
            <span>钱包网络</span>
            <div class="network-switch" :class="{ locked: isLocked('usdt') }">
              <button
                v-for="item in usdtNetworks"
                :key="item"
                type="button"
                class="network-btn"
                :class="{ active: form.usdt.bank_name === item }"
                :disabled="isLocked('usdt')"
                @click="setUsdtNetwork(item)"
              >
                {{ item }}
              </button>
            </div>
          </label>
          <label class="field">
            <span>USDT地址</span>
            <input v-model.trim="form.usdt.account_no" type="text" placeholder="请输入钱包地址" :disabled="isLocked('usdt')" />
          </label>
        </div>

        <div class="binding-tip">绑定成功后提现直接选择已绑定账号；如需更换，请联系客服。</div>
      </section>

      <button class="submit-btn" type="button" :disabled="saving || isLocked(activeType)" @click="submit">
        {{ saving ? '提交中...' : '确认绑定' }}
      </button>

      <section class="form-card" v-if="hasBinding">
        <div class="section-title">已绑定账户</div>
        <div class="binding-item" v-if="bindings.bank">
          <strong>银行卡</strong>
          <span>{{ bindings.bank.account_name }} / {{ bindings.bank.account_no }}</span>
        </div>
        <div class="binding-item" v-if="bindings.alipay">
          <strong>支付宝</strong>
          <span>{{ bindings.alipay.account_name }} / {{ bindings.alipay.account_no }}</span>
          <img v-if="bindings.alipay.qrcode_url" :src="bindings.alipay.qrcode_url" alt="支付宝收款码" class="binding-qrcode" />
        </div>
        <div class="binding-item" v-if="bindings.usdt">
          <strong>USDT</strong>
          <span>{{ bindings.usdt.account_name }} / {{ bindings.usdt.account_no }} / {{ bindings.usdt.bank_name }}</span>
        </div>
      </section>
      </template>
      <div v-else class="prerequisite-loading">正在跳转实名认证...</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addBankCard',
  data() {
    return {
      realname: '',
      birthday: '',
      mailVerifiedAt: '',
      canBindPayout: false,
      prerequisiteChecked: false,
      redirectingToRealname: false,
      activeType: 'bank',
      saving: false,
      bindings: {
        bank: null,
        alipay: null,
        usdt: null
      },
      form: {
        bank: { bank_name: '', account_no: '' },
        alipay: { account_no: '', qrcode_file: null, qrcode_preview: '' },
        usdt: { bank_name: 'TRC20', account_no: '' }
      },
      tabs: [
        { key: 'bank', label: '银行卡' },
        { key: 'alipay', label: '支付宝' },
        { key: 'usdt', label: 'USDT' }
      ],
      usdtNetworks: [
        'TRC20',
        'ERC20'
      ]
    };
  },
  computed: {
    hasBinding() {
      return !!(this.bindings.bank || this.bindings.alipay || this.bindings.usdt);
    },
    hasPayoutPrerequisites() {
      return !!(this.realname && this.mailVerifiedAt);
    }
  },
  created() {
    const queryType = (this.$route && this.$route.query && this.$route.query.type) ? String(this.$route.query.type) : '';
    if (['bank', 'alipay', 'usdt'].includes(queryType)) {
      this.activeType = queryType;
    }
    this.checkPayoutPrerequisites();
  },
  methods: {
    notify(type, message) {
      if (this.$parent && typeof this.$parent.showTost === 'function') {
        this.$parent.showTost(type, message);
      }
    },
    loading(on) {
      if (this.$parent && typeof this.$parent.showLoading === 'function' && typeof this.$parent.hideLoading === 'function') {
        if (on) {
          this.$parent.showLoading();
        } else {
          this.$parent.hideLoading();
        }
      }
    },
    isLocked(type) {
      return !!this.bindings[type];
    },
    redirectToRealname() {
      if (this.redirectingToRealname) {
        return;
      }
      this.redirectingToRealname = true;
      this.$router.replace({ path: '/realnameAuth' });
    },
    checkPayoutPrerequisites() {
      this.loading(true);
      this.$apiFun.post('/api/realname-status', {}).then(res => {
        if (res.code !== 200 || !res.data) {
          throw new Error('实名状态不可用');
        }
        this.realname = res.data.realname || '';
        this.birthday = res.data.birthday || '';
        this.mailVerifiedAt = res.data.mail_verified_at || '';
        this.canBindPayout = this.hasPayoutPrerequisites;
        this.prerequisiteChecked = true;
        if (!this.hasPayoutPrerequisites) {
          this.redirectToRealname();
          return;
        }
        this.loadBindings();
      }).catch(err => {
        console.error('提现账号绑定前置检查失败:', err);
        this.prerequisiteChecked = true;
        this.redirectToRealname();
      }).finally(() => {
        this.loading(false);
      });
    },
    loadBindings() {
      this.loading(true);
      this.$apiFun.get('/api/payout-binding-list', {}).then(res => {
        if (res.code === 200 && res.data) {
          const list = res.data.bindings || [];
          const map = { bank: null, alipay: null, usdt: null };
          list.forEach(item => {
            if (map[item.type] !== undefined) {
              map[item.type] = item;
            }
          });
          this.bindings = map;
          if (map.bank) {
            this.form.bank.bank_name = map.bank.bank_name || '';
            this.form.bank.account_no = map.bank.account_no || '';
          }
          if (map.alipay) {
            this.form.alipay.account_no = map.alipay.account_no || '';
            this.revokeAlipayPreview();
            this.form.alipay.qrcode_file = null;
            this.form.alipay.qrcode_preview = map.alipay.qrcode_url || '';
          } else {
            this.revokeAlipayPreview();
            this.form.alipay.qrcode_file = null;
            this.form.alipay.qrcode_preview = '';
          }
          if (map.usdt) {
            this.form.usdt.bank_name = map.usdt.bank_name || 'TRC20';
            this.form.usdt.account_no = map.usdt.account_no || '';
          }
        }
      }).finally(() => {
        this.loading(false);
      });

    },
    buildPayload() {
      if (this.activeType === 'bank') {
        return {
          type: 'bank',
          account_name: this.realname,
          bank_name: this.form.bank.bank_name,
          account_no: this.form.bank.account_no
        };
      }
      if (this.activeType === 'alipay') {
        return {
          type: 'alipay',
          account_name: this.realname,
          account_no: this.form.alipay.account_no
        };
      }
      return {
        type: 'usdt',
        account_name: this.realname,
        bank_name: this.form.usdt.bank_name,
        account_no: this.form.usdt.account_no
      };
    },
    submit() {
      if (this.saving) {
        return;
      }
      if (!this.realname) {
        this.notify(0, '请先填写实名认证信息');
        return;
      }
      if (!this.mailVerifiedAt) {
        this.notify(0, '请先完成邮箱验证');
        return;
      }
      if (!this.canBindPayout) {
        this.notify(0, '请先完成实名认证信息');
        return;
      }
      const payload = this.buildPayload();
      if (this.activeType === 'bank') {
        if (!payload.bank_name || !payload.account_no) {
          this.notify(0, '请完善银行卡信息');
          return;
        }
      } else if (this.activeType === 'alipay') {
        if (!payload.account_no) {
          this.notify(0, '请输入支付宝账号');
          return;
        }
        if (!this.form.alipay.qrcode_file && !this.form.alipay.qrcode_preview) {
          this.notify(0, '请上传支付宝收款码');
          return;
        }
      } else if (!payload.account_no) {
        this.notify(0, '请输入USDT地址');
        return;
      }

      this.saving = true;
      this.loading(true);
      const requestPayload = this.activeType === 'alipay'
        ? (() => {
            const formData = new FormData();
            formData.append('type', payload.type);
            formData.append('account_name', payload.account_name);
            formData.append('account_no', payload.account_no);
            if (payload.bank_name) {
              formData.append('bank_name', payload.bank_name);
            }
            if (this.form.alipay.qrcode_file) {
              formData.append('qrcode', this.form.alipay.qrcode_file);
            }
            return formData;
          })()
        : payload;
      this.$apiFun.post('/api/payout-binding-store', requestPayload).then(res => {
        this.loading(false);
        this.saving = false;
        if (res.code !== 200) {
          this.notify(0, res.message || '绑定失败');
          return;
        }
        this.notify(1, res.message || '绑定成功');
        this.loadBindings();
      }).catch(() => {
        this.loading(false);
        this.saving = false;
        this.notify(0, '网络异常');
      });
    },
    onAlipayQrcodeChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }
      if (this.form.alipay.qrcode_preview && this.form.alipay.qrcode_preview.startsWith('blob:')) {
        URL.revokeObjectURL(this.form.alipay.qrcode_preview);
      }
      this.form.alipay.qrcode_file = file;
      this.form.alipay.qrcode_preview = URL.createObjectURL(file);
    },
    pickAlipayQrcode() {
      if (this.$refs.alipayQrcodeInput) {
        this.$refs.alipayQrcodeInput.click();
      }
    },
    setUsdtNetwork(name) {
      if (this.isLocked('usdt')) {
        return;
      }
      this.form.usdt.bank_name = name;
    },
    revokeAlipayPreview() {
      const preview = this.form.alipay.qrcode_preview;
      if (preview && preview.startsWith('blob:')) {
        URL.revokeObjectURL(preview);
      }
    }
  },
  beforeDestroy() {
    this.revokeAlipayPreview();
  }
};
</script>

<style scoped>
.bind-page {
  min-height: 100vh;
  background: #f5f7fb;
}

.page-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 46px;
  line-height: 46px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  background: url(/img/counter/top-bg.webp) no-repeat #084ccb;
  z-index: 1000;
}

.back-btn {
  width: 16px;
  height: 16px;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.page-body {
  padding: 62px 14px 28px;
}

.notice-card,
.form-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 12px;
}

.notice-title {
  font-size: 16px;
  font-weight: 700;
  color: #1d2635;
}

.notice-text,
.binding-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #8b95a9;
  line-height: 1.5;
}

.section-title {
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 700;
  color: #1d2635;
}

.readonly-input {
  width: 100%;
  height: 40px;
  border: 0;
  outline: none;
  background: #f5f7fb;
  border-radius: 8px;
  padding: 0 12px;
  box-sizing: border-box;
  color: #1d2635;
}

.tab-row {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.tab-btn {
  flex: 1;
  height: 36px;
  border: 0;
  border-radius: 8px;
  background: #f3f6fb;
  color: #5c667a;
}

.tab-btn.active {
  background: #084ccb;
  color: #fff;
}

.field {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #edf1f7;
}

.field:last-child {
  border-bottom: none;
}

.field span {
  width: 78px;
  flex-shrink: 0;
  color: #576277;
  font-size: 14px;
}

.field input,
.field select {
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #1d2635;
}

.network-switch {
  flex: 1;
  display: flex;
  gap: 8px;
}

.network-switch.locked {
  opacity: 0.7;
}

.network-btn {
  flex: 1;
  height: 36px;
  border: 1px solid #dbe3f1;
  border-radius: 8px;
  background: #f7f9fd;
  color: #5c667a;
  font-size: 14px;
}

.network-btn.active {
  border-color: #084ccb;
  background: #eaf1ff;
  color: #084ccb;
}

.network-btn:disabled {
  opacity: 0.7;
}

.upload-field {
  align-items: flex-start;
}

.upload-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.upload-input {
  display: none;
}

.upload-btn {
  width: 110px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  background: #eaf1ff;
  color: #084ccb;
  font-size: 13px;
}

.upload-btn:disabled {
  opacity: 0.6;
}

.upload-preview img,
.binding-qrcode {
  width: 92px;
  height: 92px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #edf1f7;
}

.submit-btn {
  width: 100%;
  height: 44px;
  border: 0;
  border-radius: 22px;
  background: linear-gradient(135deg, #2f6df6, #084ccb);
  color: #fff;
  font-size: 16px;
  margin-bottom: 12px;
}

.submit-btn:disabled {
  opacity: 0.6;
}

.binding-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 0;
  border-top: 1px solid #edf1f7;
  color: #4d5668;
  font-size: 13px;
}

.binding-item strong {
  color: #1d2635;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/addBankCard.vue